import { Modal } from "antd";
import Styles from "../css/vehicleModals.module.scss";
import Cancel from "../../../../assets/cancel.svg";
import { useState } from "react";

const PayWithQuickbucksCancelModal = (props: any) => {
  const {selectedReasonId} = props;
  const reasonList = [
    { id: "1", name: "Price change" },
    { id: "2", name: "Non availability" },
    { id: "3", name: "I choose the wrong item" },
    { id: "4", name: "I choose the wrong tenure/equity contribution" },
    { id: "5", name: "I choose the wrong address" },
    { id: "6", name: "I no longer want this item" },
    { id: "7", name: "I want another item" },
    { id: "8", name: "Others" },
  ];

  return (
    <div>
      <Modal
        title="Basic Modal"
        centered
        destroyOnClose={true}
        width={400}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
      >
        <div className={Styles.modalContentVerification}>
          <div className={Styles.cancelDiv}>
            <img
              onClick={props.handleCancel}
              src={Cancel}
              className={Styles.cancelIcon}
              alt="horse"
            />
          </div>
          <div style={{ textAlign: "center" }} className={Styles.title}>
            Reasons for cancellation
          </div>
          <div>
            {reasonList?.map((item, index) => (
              <button
                key={index}
                className={Styles.rejectBtn}
                style={{
                  border:
                    item.id === selectedReasonId ? "2px solid #666DFF" : "",
                }}
                onClick={() => props.onSelectedReason(item)}
              >
                <div>{item.name}</div>
                <div
                  style={{
                    background: item.id === selectedReasonId ? "#666DFF" : "",
                  }}
                  className={Styles.selectedIcon}
                />
              </button>
            ))}

            {selectedReasonId === "8" && (
              <textarea onChange={props.inputedCancelReason} className={Styles.textArea} placeholder="Tell us why" />
            )}
          </div>

          {selectedReasonId &&
           <button
           onClick={props.handleLoanCancelled}
           className={Styles.btnOutline}
         >
           CANCEL TRANSACTION
         </button>
          }
         
        </div>
      </Modal>
    </div>
  );
};

export default PayWithQuickbucksCancelModal;
